import React from "react";
import {Button as AntInput} from "antd";
import styled from "styled-components"

export const ButtonGhost = styled(AntInput)`

  &.ant-btn{
    height: 48px;
    min-width: 100px;
    background: #E9F3F9;
    border-radius: 3px;
    font-family: 'Inter';
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    line-height: 18px;
    
    
    /* White */
    
    color: #E9F3F9;
  }
  
  &.ant-btn-default{
    height: 48px;
    min-width: 100px;
    background: #E9F3F9;
    border-radius: 3px;
    font-family: 'Inter';
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    line-height: 18px;
    border-color: #E9F3F9;
    
    /* White */
    
    color: #208AC6;
  }
  
  &.ant-btn-default:hover{
    background: #E9F3F9;

    border-radius: 3px;
    border: 1px solid #E9F3F9;
    color: #208AC6;
  }
  &.ant-btn-default:active{
    background: #E9F3F9;
    
    border-radius: 3px;
    color: #208AC6;
    border: 3px solid #E9F3F9;
  }
  
  &.ant-btn-block{
    width: 100%;
  }
`
